/* ============================================================================
 * SYLONI® · Auto-Hooks (Batch 1)
 *
 * 自动给 Horizon 原生组件挂上 SYLONI motion 数据属性，
 * 不修改 Horizon 任何官方文件。
 *
 * Hooks added:
 *   1. Tilt: .product-card, .collection-card, .review (Horizon block class names)
 *   2. Magnetic: button[data-style="primary"], .product-form__submit, .button--primary
 *   3. Ripple: 全站所有 button 自动有（由 syloni-ripple.js 监听 document）
 *
 * Run order: AFTER syloni-tilt/magnetic/ripple init (uses MutationObserver to
 * catch dynamically added DOM and re-attach).
 *
 * Last update: 2026-04-27 · Batch 1 v0.4.0
 * ============================================================================ */

(function () {
  'use strict';

  // Horizon component selectors that should get tilt
  const TILT_TARGETS = [
    '.product-card',
    '.collection-card',
    '.review',
    '.featured-product-card',
    '[data-product-card]',
  ];

  // Horizon component selectors that should get magnetic
  const MAGNETIC_TARGETS = [
    '.button--primary',
    'button[data-style="primary"]',
    '.product-form__submit',
    '.add-to-cart-button',
    'button[name="add"]',
  ];

  function attachHooks(root) {
    const scope = root || document;

    // Tilt hooks
    TILT_TARGETS.forEach((sel) => {
      scope.querySelectorAll(sel).forEach((el) => {
        if (!el.hasAttribute('data-syloni-tilt')) {
          el.setAttribute('data-syloni-tilt', '');
        }
      });
    });

    // Magnetic hooks
    MAGNETIC_TARGETS.forEach((sel) => {
      scope.querySelectorAll(sel).forEach((el) => {
        if (!el.hasAttribute('data-syloni-magnetic')) {
          el.setAttribute('data-syloni-magnetic', '');
        }
      });
    });

    // Re-init motion controllers on the newly tagged elements
    if (window.SYLONI && window.SYLONI.modules) {
      if (window.SYLONI.modules.tilt) window.SYLONI.modules.tilt.initAll(scope);
      if (window.SYLONI.modules.magnetic) window.SYLONI.modules.magnetic.initAll(scope);
    }
  }

  function init() {
    attachHooks();

    // Watch for dynamic DOM (theme editor section reload, AJAX cart update, etc.)
    if ('MutationObserver' in window) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((m) => {
          m.addedNodes.forEach((node) => {
            if (node.nodeType === 1) {
              attachHooks(node);
            }
          });
        });
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor lifecycle
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target) attachHooks(e.target);
  });

  if (window.SYLONI) {
    window.SYLONI.modules.autoHooks = {
      version: '0.4.0',
      attachHooks,
      tiltTargets: TILT_TARGETS,
      magneticTargets: MAGNETIC_TARGETS,
    };
  }

  console.log(
    '%c SYLONI auto-hooks v0.4.0 ',
    'background:#D4AF37;color:#0A0A0A;padding:3px 8px;font-family:monospace;letter-spacing:2px;font-weight:600;'
  );
})();
